import { useAtomValue } from 'jotai';
import { DevTools } from 'jotai-devtools';
import { useEffect } from 'react';
import { jotaiDevtoolsVisibleAtom } from '@/atoms/debug';
export const JotaiDevTools = () => {
  const isVisible = useAtomValue(jotaiDevtoolsVisibleAtom);
  useEffect(() => {
    // ponytail: styles loaded lazily only once the panel is enabled in dev
    if (process.env.NODE_ENV === 'development' && isVisible) {
      import('jotai-devtools/styles.css' as string);
    }
  }, [isVisible]);
  if (process.env.NODE_ENV !== 'development' || !isVisible) {
    return null;
  }
  return <DevTools position="top-left" data-sentry-element="DevTools" data-sentry-component="JotaiDevTools" data-sentry-source-file="JotaiDevTools.tsx" />;
};